import { z } from 'zod';

import { CollateralOnlyCategory } from '../types/CollateralCategory';
import { ComponentFileType } from '../types/ComponentFileType';
import { FileSchema } from '../types/File.schema';

const CollateralSchema = z.object({
    id: z.string(),
    company: z.string().optional().nullable(),
    file: z.union([z.string(), FileSchema]).optional().nullable(),
    videoUrl: z.string().optional().nullable(),
    videoThumbnail: z.string().optional().nullable(),
    title: z.string().min(1, 'Give this collateral a title'),
    description: z.string().max(160, 'Keep it under 160 characters').optional().nullable(),
    category: z
        .union([z.nativeEnum(ComponentFileType), z.nativeEnum(CollateralOnlyCategory)])
        .optional()
        .nullable(),
    product: z.string().optional().nullable(),
    createdAt: z.string().optional(),
});

const CollateralPayloadSchema = CollateralSchema.omit({ id: true, createdAt: true, videoThumbnail: true });

export { CollateralPayloadSchema, CollateralSchema };
